import PubSub from "./pubsub.js";
import anime from "./anime.es.js";

///////////////////////////////
// ENHANCED MENU MOBILE TRIGGER
///////////////////////////////
if (!customElements.get("enhanced-mobile-menu-trigger")) {
  class EnhancedMobileMenuTrigger extends HTMLElement {
    constructor() {
      super();

      this.pubsub = PubSub;
      this.btn = this.querySelector("button");
    }

    handleClick = (e) => {
      this.pubsub.pub("mobile-menu:open");
    };

    connectedCallback() {
      this.btn.addEventListener("click", this.handleClick.bind(this));
    }
    disconnectedCallback() {
      this.btn.removeEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define(
    "enhanced-mobile-menu-trigger",
    EnhancedMobileMenuTrigger
  );
}

////////////////
// ENHANCED MENU
////////////////
if (!customElements.get("enhanced-menu")) {
  class EnhancedMenu extends HTMLElement {
    constructor() {
      super();

      this.pubsub = PubSub;

      this.nav = document.querySelector(".nav-container");
      this.overlay = document.querySelector("#header-overlay");
      this.menu = this.querySelector(".enhanced-menu");
      this.close = this.querySelector('[name="close"]');
      this.topLevelPanelClosers = this.querySelectorAll(
        '[name="closeTopLevelPanel"]'
      );

      this.topLevelNavTriggers = this.querySelectorAll(
        ".top-level-nav__trigger"
      );
      this.topLevelNavPanels = this.querySelectorAll(".top-level-nav__panel");

      this.topLevelCurOpen = null;
      this.overlayIsOpen = false;

      this.device = "";
      this.headerTransparent = "";
      this.headerColor = "";
      this.headerSticky = false;

      this.menuStates = {
        transparentLight: ["is--transparent", "is--light"],
        transparentDark: ["is--transparent", "is--dark"],
        default: ["is--dark"],
      };
    }

    // HANDLE MOBiLE-MENU : OPEN
    handleMobileMenuOpen = () => {
      if (this.device === "mobile") {
        document.body.classList.add("overflow-hidden");

        if (this.headerIsSticky) {
          this.menu.classList.add("h-screen");
        }

        anime({
          targets: this.menu,
          translateX: "100%",
          easing: "easeOutElastic(1, 0.8)",
        });
      }
    };

    // HANDLE MOBILE-MENU : CLOSE
    handleMobileMenuClose = () => {
      if (this.device === "mobile") {
        document.body.classList.remove("overflow-hidden");
        anime({
          targets: this.menu,
          translateX: "0",
          easing: "easeOutElastic(1, 0.8)",
        });
      }
    };

    // HANDLE TOP LEVEL NAV TRIGGER
    handleTopLevelNavTrigger = (e) => {
      e.preventDefault();

      if (this.device === "mobile") {
        this.querySelectorAll(".top-level-nav").forEach((el) =>
          el.classList.remove("is--open")
        );
        e.target.parentElement.classList.add("is--open");
      } else {
        // https://animejs.com/documentation/#timelineBasics

        document.body.classList.add("overflow-hidden");

        switch (true) {
          case this.headerSticky === false &&
            this.headerColor === "is--light" &&
            this.headerTransparent === true:
            this.nav.classList.remove(...this.menuStates.transparentLight);
            this.nav.classList.add(...this.menuStates.default);

            break;
          case this.headerSticky === false &&
            this.headerColor === "is--dark" &&
            this.headerTransparent === true:
            this.nav.classList.remove(...this.menuStates.transparentDark);
            this.nav.classList.add(...this.menuStates.default);
            break;
          default:
        }

        // IF OVERLAY NOT OPEN
        if (this.overlayIsOpen === false) {
          // OPEN OVERLAY
          anime({
            targets: this.overlay,
            opacity: 1,
            height: "100vh",
            duration: 200,
            easing: "linear",
          }).finished.then(() => {
            // THEN OPEN MENU
            this.overlayIsOpen = true;
            this.topLevelCurOpen = e.target.nextElementSibling;

            // e.target.nextElementSibling.classList.add("panel--is--open");

            this.topLevelCurOpen.style.visibility = "visible";
            anime({
              targets: this.topLevelCurOpen,
              opacity: 1,
              delay: 0,
              duration: 200,
              easing: "linear",
            });
          });

          e.target.parentElement.classList.add("is--open");
        } else {
          // OVERLAY ALREADY OPEN
          // OPEN CLICKED MENU
          if (
            this.topLevelCurOpen != e.target.nextElementSibling &&
            this.topLevelCurOpen != null
          ) {
            anime({
              targets: this.topLevelCurOpen,
              opacity: 0,
              delay: 0,
              duration: 200,
              easing: "linear",
            }).finished.then(() => {
              this.topLevelCurOpen.style.visibility = "hidden";
              this.topLevelCurOpen.parentElement.classList.remove("is--open");
              this.topLevelCurOpen = e.target.nextElementSibling;

              this.topLevelCurOpen.style.visibility = "visible";
              anime({
                targets: this.topLevelCurOpen,
                opacity: 1,
                delay: 0,
                duration: 200,
                easing: "linear",
              });

              e.target.parentElement.classList.add("is--open");
            });
          } else {
            // NOTHING
          }
        }
      }
    };

    // CLOSE TOP LEVEL PANEL
    closeTopLevelPanel = (e) => {
      const openedGroup = this.querySelector(".top-level-nav.group.is--open");
      const openedPanel = openedGroup.querySelector(".top-level-nav__panel");

      anime({
        targets: openedPanel,
        opacity: 0,
        delay: 0,
        duration: 200,
        easing: "linear",
      }).finished.then(() => {
        openedPanel.style.visibility = "hidden";
        openedPanel.parentElement.classList.remove("is--open");
        this.topLevelCurOpen = null;

        anime({
          targets: this.overlay,
          opacity: 0,
          height: "0vh",
          duration: 200,
          easing: "linear",
        }).finished.then(() => {
          this.overlayIsOpen = false;
          document.body.classList.remove("overflow-hidden");
        });
      });

      if (
        this.nav.classList.contains("is--dark") &&
        this.nav.dataset.default === "is--transparent is--light"
      ) {
        this.nav.classList.remove("is--dark");
        this.nav.classList.add("is--transparent");
        this.nav.classList.add("is--light");
      } else {
      }

      // document.body.classList.remove("overflow-hidden");
    };

    // DEVIC EOBSERVER
    deviceObserver = () => {
      const mql = window.matchMedia("(max-width: 1279px)");

      this.device = mql.matches ? "mobile" : "desktop";

      mql.onchange = (e) => {
        if (e.matches) {
          this.device = "mobile";
        } else {
          this.device = "desktop";
        }
      };
    };

    // HEADER TYPE TRANSPARENT OR DEFAULT
    getHeaderType = () => {
      this.headerTransparent = document
        .querySelector(".nav-container")
        .classList.contains("is--transparent")
        ? true
        : false;
    };

    // GET HEADR TEXT COLOR
    getHeaderTextColor = () => {
      this.headerColor = document
        .querySelector(".nav-container")
        .classList.contains("is--light")
        ? "is--light"
        : document
            .querySelector(".nav-container")
            .classList.contains("is--dark")
        ? "is--dark"
        : null;
    };

    // HANDLE MOBILE MENU STICKY
    handleMobileMenuSticky = (data) => {
      this.headerIsSticky = data.isSticky;
    };

    connectedCallback() {
      this.pubsub.sub("mobile-menu:open", this.handleMobileMenuOpen.bind(this));
      this.pubsub.sub(
        "mobile-menu:is--sticky",
        this.handleMobileMenuSticky.bind(this)
      );

      this.close.addEventListener(
        "click",
        this.handleMobileMenuClose.bind(this)
      );
      this.topLevelNavTriggers.forEach((trigger) =>
        trigger.addEventListener(
          "click",
          this.handleTopLevelNavTrigger.bind(this)
        )
      );

      this.topLevelPanelClosers.forEach((closeBtn) => {
        closeBtn.addEventListener("click", this.closeTopLevelPanel.bind(this));
      });

      this.deviceObserver();
      this.getHeaderType();
      this.getHeaderTextColor();
    }
    disconnectedCallback() {}
  }

  customElements.define("enhanced-menu", EnhancedMenu);
}
